<template>
  <div class="market-couponGrant-index">
    <!-- <Search :renderData="renderData" :formData="form" :labelWidth="100" @onSearch="onSearch" ></Search> -->
    <div class="fun-btn-box">
      <auth-button auth="market:coupon:task:create">
        <el-button type="primary" class="fun-btn mr10" @click="onAdd" >+ 发券</el-button>
        <el-button type="default" class="fun-btn mr10"  @click="onUp"  :loading="exportLoading" >批量导入</el-button>
        <el-button type="default" class="fun-btn mr10" @click="onDown" >模板下载</el-button>
        <el-button slot="default" class="fun-btn mr10"  @click="onExport" :loading="exportCouponLoading" >导出</el-button>
      </auth-button>
    </div>
      <Table
        ref="table"
        :tableThData="tableThData"
        :tableTrData="tableTrData"
        :loading="loading"
        :limit="limit"
        :total="total"
        :offset="offset"
        :selection="true"
        @selectTable="selectTable"
        @selectTable_all="selectTable_all"
        v-on:handleSizeChange="handleSizeChange"
        v-on:handleCurrentChange="handleCurrentChange"
      >
      <template #name="{ row }">{{ row.name }}</template>
      <template #userTargetType="{ row }">{{ row.userTargetType }}</template>
      <template #status="{ row }">{{ couponTaskStatusObj[row.status] }}</template>
      <template #startTime="{ row }">{{ row.startTime ? $moment(row.startTime).format('YYYY/MM/DD HH:mm') : '---' }}</template>
      <template #created="{ row }">{{ row.created ? $moment(row.created).format('YYYY/MM/DD HH:mm:ss') : '---' }}</template>
      <template #operatorName="{ row }">{{ row.operatorName }}</template>
      <template #operation="{ scope }">
        <auth-button auth="market:coupon:task:delete">
          <el-button v-if="scope.row.importBool" class="error" type="text" @click="onChangeEdit(scope.row)">编辑</el-button>
          <el-button v-if="scope.row.status == 'New'" class="error" type="text" @click="onChangeStatus(scope.row)">删除</el-button>
        </auth-button>
      </template>
    </Table>
   <!-- 用户导入对话框 -->
   <input ref="code-import-input" id="the_inputfile" class="code-import-input" type="file" accept=".xlsx, .xls" @change="submitFile">
  </div>
</template>

<script>
import XLSX from 'xlsx'
import AuthButton from '@/components/AuthButton'
import tableList from '@/mixins/tableList'
import { api_delCouponGrant, api_getDownloadExcel, api_getImportExcelExcel, api_getNewCouponGrantList,api_getMarketCouponTaskExportRecord} from '@/api/market'
import { api_getConfig } from '@/api/common'
import Search from "@/components/Search/index";
import Table from "@/components/Table/index";
import { downFile } from "@/utils";
export default {
  name: "marketCouponGrantIndex",
  mixins: [ tableList ],
  components: {
    AuthButton,
    Search,
    Table,
  },
  data() {
    return {
      renderData: [
        {
          label: "优惠券名称",
          placeholder: "请输入优惠券名称",
          type: "input",
          key: "name",
        },
      ],
      form: {},
      tableThData: [
        { prop: "name", label: "优惠券", minWidth: "180", },
        { prop: "userTargetType", label: "发券对象", minWidth: "180", },
        { prop: "status", label: "发券状态", minWidth: "180", },
        { prop: "startTime", label: "发放时间", minWidth: "180", },
        { prop: "created", label: "创建时间", minWidth: "180", },
        { prop: "operatorName", label: "操作人", minWidth: "180", },
        { prop: "operation", label: "操作", minWidth: "150", },
      ],
        selectedIds:[],
        selectedData:[],
        couponTaskStatusObj: {}, // 发券任务状态枚举
        exportLoading:false,
        exportCouponLoading:false
    };
  },
  created () {
    this.getConfig() // 获取config数据
  },
  methods: {
    // 获取config数据
    async getConfig() {
      const {couponTaskStatus} = await api_getConfig('couponTaskStatus')
      let obj = {}
      couponTaskStatus.forEach(item => {
        obj[item.name] = item.desc
      })
      this.couponTaskStatusObj = obj
    },
    // 获取表格列表数据
    async getList () {
      this.loading = true
      const params = {
        ...this.form,
        offset: this.offset,
        limit: this.limit,
      }
      this.$router.push({query: params})
      const data = await api_getNewCouponGrantList(params)
      console.log('data: ', data);
      this.tableTrData = data.list || []
      this.total = data.count
      this.loading = false
      this.handleEchoSelect() // 回显选中项
    },
      // 禁用选项
    checkSelectable_all(row) {
      return row.status == 'Finished'
    },
      // 回显选中项
    handleEchoSelect() {
      let selectRow = this.tableTrData.filter(item => this.selectedIds.indexOf(item.id) >= 0)
      setTimeout(() => {
        selectRow.forEach(item => {
          this.$refs.table.$refs.myTable.toggleRowSelection(item, true);
        })
      }, 100)
    },
      // 表格单选选择
      selectTable(selection, row) {
        let curRowIndex = selection.findIndex(item => item.id == row.id)
        if (curRowIndex >= 0) {
          // 选择
          this.selectedData.push(row)
        } else {
          // 取消选择
          this.selectedData = this.selectedData.filter(item => item.id !== row.id)
        }
        this.selectedIds = this.selectedData.map(item => item.id)
      },

      // 表格全选选择
      selectTable_all(selection) {
        if (selection.length) {
          // 全选
          let curRow = this.tableTrData.filter(item => this.selectedIds.indexOf(item.id) < 0)
          this.selectedData = [...this.selectedData, ...curRow]
        } else {
          // 取消全选
          let curTableIds = this.tableTrData.map(item => item.id)
          this.selectedData = this.selectedData.filter(item => curTableIds.indexOf(item.id) < 0)
        }
        this.selectedIds = this.selectedData.map(item => {
          if(item.status == 'Finished'){
            return item.id
          }else{
            return ''
          }
        })
        console.log(this.selectedIds)
      },
    // 点击发券按钮
    onAdd() {
      this.$router.push({
        path: "/market/couponGrant/add"
      });
    },

    // 点击批量导入按钮
    async onUp() {
      this.$refs['code-import-input'].click()
    },


    // 提交导入
    async submitFile(e){
      console.log("提交导入")
      try {
        this.exportLoading = true
        const files = e.target.files
        console.log(files)
        let res = await api_getImportExcelExcel({
          file: files[0]
        })
        this.$baseMessage(res.message, 'success')
        this.exportLoading = false
        document.getElementById('the_inputfile').value = '';	
        this.getList()
      } catch (err) {
        console.log('err: ', err);
        this.$baseMessage('批量导入失败', 'error');
        this.exportLoading = false
        this.getList()
      }
    },

    //编辑导入数据
    onChangeEdit(row){
      console.log(row)
      this.$router.push({
        name: 'marketCouponGrantAdd',
        params: row,
      });
    },

    // 点击模板下载
    async onDown() {
      const res = await api_getDownloadExcel()
      const blob = new Blob([res.data]);
      let url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "手动发券模板.xlsx"; //命名Excel名字
      link.click();
      URL.revokeObjectURL(url);
      this.downLoad = false
    },

    // 导出
    async onExport() {
      if (this.selectedIds.length==0){
        this.$baseMessage('请选择需要导出的数据', 'error')
        return
      }
      this.exportCouponLoading = true
      let newarr = this.selectedIds.filter(item=>!["",null,undefined,NaN,false,true].includes(item));
      const params = {
        ids:newarr.join(',')
      }
      let res = await api_getMarketCouponTaskExportRecord(params)
      downFile(res)
      this.exportCouponLoading = false
    },

    // 更改状态
    onChangeStatus(row) {
      this.$baseConfirm(
        '是否要删除该发券任务？',
        { title: '提示', type: 'warning', },
        async () => {
          await api_delCouponGrant({id: row.id})
          this.$baseMessage('操作成功', 'success')
          this.getList()
        }
      )
    },

  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.market-couponGrant-index {
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;

  .fun-btn-box {
    margin-top: 20px;
  }
  .status{
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
  }

  .del {
    color: #F74A4A;
  }
  .dot-success{
    background: #05c8af;
  }

  .dot-clear {
    background: #F74A4A;
  }

  .dot-ing {
    background: #3775FF;
  }

  .dot-new {
    background: #ccc;
  }

  .code-import-input {
    height: 0px;
    visibility: hidden;
  }
}
</style>
